import Moment from "moment";

//Gönderilen Tarih-Saat formatını gün ay ve yıl olarak düzenler.
export const dateTemplate = (value) => {
        return (Moment(value).format('DD.MM.YYYY'));
}

export const filter = (data, columnName) => {
        let result = [];
        if(columnName.split('.').length>1){
                data.map(item => {
                                var isExist = result.filter(x => x.text === item[columnName.split('.')[0]][columnName.split('.')[1]] && x.value === item[columnName.split('.')[0]][columnName.split('.')[1]]);
                                if (isExist.length === 0)
                                        result.push({
                                                text: item[columnName.split('.')[0]][columnName.split('.')[1]],
                                                value: item[columnName.split('.')[0]][columnName.split('.')[1]]
                                        })
                        })

        }else{
                data.map(item => {
                                var isExist = result.filter(x => x.text === item[columnName] && x.value === item[columnName]);
                                if (isExist.length === 0)
                                        result.push({
                                                text: item[columnName],
                                                value: item[columnName]
                                        })
                        })

        }
        // eslint-disable-next-line array-callback-return
       
        return result
}

export const dateFilter = (data, columnName) => {
        let result = [];
        // eslint-disable-next-line array-callback-return
        data.map(item => {
                var isExist = result.filter(x => x.text === dateTemplate(item[columnName]) && x.value === dateTemplate(item[columnName]));
                if (isExist.length === 0)
                        result.push({
                                text: dateTemplate(item[columnName]),
                                value: dateTemplate(item[columnName])
                        })
        })
        return result
}